<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3" v-if="item.id">
            {{ $t('addEditAccessoire.titleEdit') }}
          </h1>
          <h1 class="title is-size-3" v-else>
            {{ $t('addEditAccessoire.titleAdd') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component
        :messages="messages"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :error="error"
        :title="'general.problemOccurred'"
        :withEmplyFields="true"
        @close="error = $event"/>
      <div class="columns is-multiline">
        <b-field
          :label="$t('addEditAccessoire.information.libelle')"
          class="obligatoire column is-6 mgb-0">
          <b-input v-model="item.libelle"></b-input>
        </b-field>
        <b-field
          :label="$t('addEditAccessoire.information.fournisseur')"
          class="column is-6 mgb-0">
          <b-autocomplete
              v-model="fournisseurSelect"
              :data="fournisseurs"
              field="nomCommercial"
              open-on-focus
              @typing="getFournisseur"
              :loading="isFetching"
              @select="fournisseur => selectFournisseur(fournisseur)">
              <template slot="empty">
                <div v-if="!isFetching">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
                <div v-else>
                  {{$t('general.autocomplete.search')}}
                </div>
              </template>
            </b-autocomplete>
        </b-field>
        <b-field
          :label="$t('addEditAccessoire.information.commentaire')"
          class="column is-12 mgb-0">
          <b-input v-model="item.commentaire" type="textarea"></b-input>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="save()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { create, update } from '@/api/accessoire/index';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import validation from '@/services/validation/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { TIERS_TYPE_FOURNISSEUR, TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL } from '@/configuration/tiers/tiersConf';
import { getAll } from '@/api/tiers';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      isFetching: false,
      fournisseurs: [],
      fournisseurSelect: null,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
    }),
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        if (this.item.id) {
          await update(this.item);
          messageSuccess(this.$i18n.t('addEditAccessoire.success.edit'));
        } else {
          await create(this.item);
          messageSuccess(this.$i18n.t('addEditAccessoire.success.add'));
        }
        await this.loadParametreForce(typesParametres.PARAMETRES_KEYS.accessoire);
        loadingComponent.close();
        this.$emit('reload');
        this.$parent.close();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validation(
            this.$i18n,
            e.response,
            this.champsVide,
            this.messages,
            this.messagesChampsVide,
            null,
          );
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getFournisseur: debounce(async function fournisseurData(text) {
      try {
        this.fournisseurs = [];
        this.isFetching = true;
        this.item.fournisseurId = null;
        this.fournisseurs = (await getAll({
          query: {
            auto: text,
            societeId: this.societeActiveId,
            type: TIERS_TYPE_FOURNISSEUR,
            sousType: [TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL],
            archive: false,
          },
          limit: NO_PAGINATION,
        })).data.result.items;
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
    selectFournisseur(newfournisseur) {
      if (!newfournisseur) return;
      this.fournisseurSelect = newfournisseur.nomCommercial;
      this.item.fournisseurId = newfournisseur.id;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.item.fournisseurId) this.fournisseurSelect = this.item.fournisseur.nomCommercial;
      await this.getFournisseur();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};

</script>
